module.exports = __webpack_public_path__ + "img/smoke.8f922591.png";